const HtmlToString = ({ html }) => {
  if (html === null || html === "" || html === undefined) return false;
  return html.toString().replace(/(<([^>]+)>)/gi, "");
};

export default HtmlToString;
